<template>
  <div class="kst-layout">
    <Nav
      :userData="userData"
      @menu="handleMenu_Open"
    />

    <div class="is-flex">
      <div class="is-hidden-touch ks-border-r-light kst-layout-sidebar kst-layout-sidebar-width">
        <div class="px-4 kst-layout-sidebar-menu">
          <kst-menu :items="menu"/>
        </div>
        <About />
      </div>
      <kst-modal full-screen
        class="kst-layout-sidebar-modal"
        title="Menu"
        :active="menuIsActive"
        @cancel="handleMenu_Close"
      >
        <div class="ks-border-r-light kst-layout-sidebar kst-layout-sidebar-width">
          <div class="px-4 kst-layout-sidebar-menu">
            <kst-menu :items="menu" @submit="handleMenu_Close"/>
          </div>
          <About />
        </div>
      </kst-modal>

      <kst-page>
        <router-view />
      </kst-page>
    </div>
  </div>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import Menu from "./LayoutMenu.js";

import Nav from "./Layout_Nav";
import About from "./Layout_About";

export default {
  mixins: [AxiosMixin],
  components: {
    Nav,
    About
  },
  data: () => ({
    userData: {},
    menu: Menu.getList(),
    menuIsActive: false
  }),
  created() {
    this.init();
  },
  methods: {
    init() {
      this.userData = {
        Search: "",
      }
    },

    handleMenu_Open() {
      this.menuIsActive = true;
    },
    handleMenu_Close() {
      this.menuIsActive = false;
    }
  }
}
</script>

<style>
@import "./_layout.css";
</style>